import { render, staticRenderFns } from "./PopupDialogComponent.vue?vue&type=template&id=71bb3b78&scoped=true&"
import script from "./PopupDialogComponent.vue?vue&type=script&lang=js&"
export * from "./PopupDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialogComponent.vue?vue&type=style&index=0&id=71bb3b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb3b78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
